import { createTheme } from "@mui/material";

export const createApraoTheme = (config?: { disableAnimations?: boolean }) =>
  createTheme({
    palette: {
      primary: {
        main: "#003a5f",
        light: "#3c648d",
        dark: "#001435",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#f7b179",
        light: "#ffe3a9",
        dark: "#c2814c",
        contrastText: "#000000",
      },
      background: {
        default: "#f5f9fc",
      },
    },
    ...(config?.disableAnimations && {
      transitions: {
        create: () => "none",
      },
      components: {
        MuiButtonBase: {
          defaultProps: { disableRipple: true },
        },
      },
    }),
  });
